import { render, staticRenderFns } from "./communication.vue?vue&type=template&id=5b56bc46&scoped=true&"
import script from "./communication.vue?vue&type=script&lang=js&"
export * from "./communication.vue?vue&type=script&lang=js&"
import style0 from "./communication.vue?vue&type=style&index=0&id=5b56bc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56bc46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b56bc46')) {
      api.createRecord('5b56bc46', component.options)
    } else {
      api.reload('5b56bc46', component.options)
    }
    module.hot.accept("./communication.vue?vue&type=template&id=5b56bc46&scoped=true&", function () {
      api.rerender('5b56bc46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/communication/communication.vue"
export default component.exports